/* eslint-disable global-require */

export default [
  {
    path: '/appointments/:id/cancel',
    getComponent(partialNextState, callback) {
      require.ensure(
        [],
        () => callback(null, require('./pages/CancelAppointmentPage').default),
        'mainCancelAppointmentPage'
      );
    },
  },
  {
    path: '/appointments/:id/reschedule',
    getComponent(partialNextState, callback) {
      require.ensure(
        [],
        () => callback(null, require('./pages/ReschedulePage').default),
        'mainReschedulePage'
      );
    },
  },
  {
    path: '/appointments/:id',
    getComponent(partialNextState, callback) {
      require.ensure(
        [],
        () => callback(null, require('./pages/AppointmentDetailPage').default),
        'mainAppointmentDetailPage'
      );
    },
  },
  {
    path: '/providers/:providerId/appointments/:id',
    getComponent(partialNextState, callback) {
      require.ensure(
        [],
        () => callback(null, require('./pages/AppointmentDetailPage').default),
        'mainAppointmentDetailPage'
      );
    },
  },
  {
    path: '/providers/:providerId/openings/:openingSlug',
    getComponent(partialNextState, callback) {
      require.ensure(
        [],
        () => callback(null, require('../shared/components/WidgetSettings').default),
        'mainAppointmentFormPage'
      );
    },
    getIndexRoute(partialNextState, callback) {
      require.ensure(
        [],
        () =>
          callback(null, {
            component: require('./pages/AppointmentFormPage').default,
          }),
        'mainAppointmentFormPage'
      );
    },
  },

  {
    path: '*',
    getComponent(partialNextState, callback) {
      require.ensure(
        [],
        () => callback(null, require('./pages/NotFoundPage').default),
        'mainDirectory'
      );
    },
  },
];



// WEBPACK FOOTER //
// ./src/main/routes.js